import numeral from 'numeral';

const key = (t) => [
    {
        label: t('discover.category.chart.impressions'),
        key: 'impressions',
        icon: 'search',
    },
    {
        key: 'clicks',
        label: t('discover.category.chart.clicks'),
        yAxisID: 'y3',
        icon: 'clicks',
    },
    {
        key: 'ctr',
        label: t('discover.category.chart.ctr'),
        format: '0.00%',
        render: (data) => numeral(data * 100).format('0.00'),
        yAxisID: 'y1',
        icon: 'ctr',
    },
    {
        key: 'pages',
        label: t('discover.category.chart.pages'),
        format: '0,00',
        yAxisID: 'y2',
        icon: 'clicks',
    },
];

export default key;
